import React, { useState, useEffect, createRef } from "react";
import "./style.scss";
import { CameraOutlined, UploadOutlined, UserOutlined } from "@ant-design/icons";
import {
  Layout,
  Space,
  Button,
  PageHeader,
  Card,
  Row,
  Col,
  Upload,
  Form,
  Input,
  Select,
  Checkbox,
  message,
  Image,
  Avatar,
  Tooltip,
} from "antd";
import TestimonialService from "../../services/TestimonialService";
import stateData from "../../constant/state.json";
import { useSelector } from "react-redux";

const { Content } = Layout;
const { Dragger } = Upload;
const { Option } = Select;

const MAX_WIDTH = 1920;
const MAX_HEIGHT = 1080;

const AddAndUpdateRestaurant = ({ editRestaurantData, isEdit, closeModal,createRestaurant }) => {
  const [loading, setLoading] = useState(false);
  const formRef = createRef();
  const [form] = Form.useForm();
  const [cusines, setCusines] = useState([]);
  const [cusineId, setCusinesId] = useState();
  const [selectedSpeciality, setSelectedSpeciality] = useState([]);
  const [speciality, setSpeciality] = useState([]);
  const adminRestaurant = useSelector((state) => state.admin);
  const [logo, setLogo] = useState("");
  const [banner, setBanner] = useState("");


  const [restaurantCodeValidationInfo, setRestaurantCodeValidationInfo] =
    useState([]);

  useEffect(() => {
    if (isEdit) {
      formRef.current.setFieldsValue({
        name: editRestaurantData.name,
        email: editRestaurantData.email,
        phone: editRestaurantData.phone,
        address: editRestaurantData.address,
        cuisine_id: editRestaurantData.cuisine_id,
        city: editRestaurantData.city,
        restaurant_code: editRestaurantData.restaurant_code,
        state: editRestaurantData.state,
        specialties: editRestaurantData?.specialties?.map(item => item.id)
      });
      setCusinesId(editRestaurantData.cuisine_id);
      setSelectedSpeciality(editRestaurantData?.specialties.map(item=>{return {...item, value: item.id}}));
      if(editRestaurantData.logo_url)
        setLogo(editRestaurantData.logo_url);
        setBanner(editRestaurantData.banner_url);
    }
  }, [isEdit]);

  useEffect(() => {
    getcusines();
    getBusiness()
  }, []);
  const getBusiness = async () => {
    const restaurant_id = adminRestaurant;
    const data = await TestimonialService.getBusiness(restaurant_id);
    
  };
  const getcusines = async () => {
    const data = await TestimonialService.getCusines();
    setCusines(data.cuisines);
  };

  

  const addRestaurant = async (restaurantData) => {
    restaurantData.business_id = +localStorage.getItem("businessId");
    restaurantData.lat = 91.9;
    restaurantData.lng = 94.3;
    restaurantData.restaurant_code =
      restaurantData?.restaurant_code?.toLowerCase();
      restaurantData.specialties = selectedSpeciality.map(item => item.value)
      restaurantData.banner_url = banner;
      restaurantData.logo_url = logo;

      // delete restaurantData.speciality

    try {
      if (isEdit) {
        await TestimonialService.updateRestaurant(
          restaurantData,
          editRestaurantData?.id
        );
        message.success("Updated Successfully");
      } else {
        await TestimonialService.addRestaurant(restaurantData);
        message.success("Added Successfully");
      }
      createRestaurant(false);
    } catch (error) {
      message.error("Failed to perform the operation. Please try again later.");
    }
  };
  useEffect(() => {
    getSpeciality()
  }, []);
  const getSpeciality = async()=>{
    const data = await TestimonialService.getSpecialities(adminRestaurant)
    setSpeciality(data);

  }
  const handleCheckboxSpeciality = (itemId,e) => {
    const updatesSpeciality = speciality.map((item) =>
      item.id === itemId
        ? { ...item, checked: e?.target?.checked ? true : false }
        : item
    );
    const updateSelection = selectedSpeciality.filter(item => item.checked);
    setSpeciality(updatesSpeciality);
    setSelectedSpeciality(updateSelection);
  };

  const handleSpeciality = (value) => {
    const values = value.map(item=> item.value);
    const updatesSpeciality = speciality.map((item) =>
      values.includes(item.id)
        ? { ...item, checked: true,key: Math.random() }
        : { ...item, checked: false,key: Math.random() }
    );
    setSpeciality(updatesSpeciality);
    setSelectedSpeciality(value);
  };

  const validateRestaurantCode = async (e) => {
    const restaurantCode = e.target.value;
    const { msg } = await TestimonialService.getRestaurantCode(
      restaurantCode.toLowerCase()
    );

    const isAvailable = msg === "Restaurant with code not found";

    setRestaurantCodeValidationInfo({
      hasFeedback: true,
      validateStatus: isAvailable ? "success" : "error",
      ...(!isAvailable && { help: "Restaurant code is not available" }),
    });

    if (isAvailable) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  };

 

  const beforeUpload = async (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    const formData = new FormData();
    formData.append("file", file);
    const dataUrl = await TestimonialService.uploadPhoto(formData);



    setLogo(dataUrl.url);
  };

  const checkResolution = async(file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
  
        reader.onload = (e) => {
          const img = new window.Image();
  
          img.onload = () => {
            const { width, height } = img;
            if (width >= MAX_WIDTH && height >= MAX_HEIGHT) {
              resolve(true);
            } else {
              resolve(false);
            }
          };
  
          img.onerror = () => {
            resolve(false);
          };
  
          img.src = e.target.result;
        };
  
        reader.onerror = () => {
          resolve(false);
        };
  
        reader.readAsDataURL(file);
      });
    };

  const beforeUploadanner = async (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return false;
    }
    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error("Image must smaller than 2MB!");
    //   return false;
    // }

    const isResolutionValid = await checkResolution(file);
    if (!isResolutionValid) 
      {
        message.error("Image resolution must be greater than 1920 X 1080");
        return false;
      }
  
    const formData = new FormData();
    formData.append("file", file);
    const dataUrl = await TestimonialService.uploadPhoto(formData);

    
    setBanner(dataUrl.url);
  };

  const handleChange = async (info) => {};

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            style={{ minHeight: 80 }}
            className="d-flex items-center page-header-business"
            title={
              <div className="flex items-center">
                <div
                  className="cursor-pointer flex"
                  onClick={() => closeModal(false)}
                >
                  <svg
                    width="25"
                    height="16"
                    viewBox="0 0 25 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="ml-1 ant-page-header-heading-title">
                  {isEdit ? " Update Restaurant" : "Add New Restaurant"}
                </div>
              </div>
            }
          />
          <div className="content-container-business">
            <Card className="add-edit-rest-card">
              <div className="card-head">
                <div className="details-text">Details</div>
                <div>Add Details Of The Restaurant</div>
              </div>
              <div>
             
              <div className="banner business-logo">
                <div
                    style={{
                      width: "100%",
                      height: "300px", // your desired banner height
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#f5f5f5", // optional background behind image
                      overflow: "hidden",
                    }}
                  >
                    <Image
                      src={banner}
                      alt="Banner"
                      preview={false}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <Tooltip title="For best results, image dimensions should exceed standard HD (1920 x 1080 pixels)." color={"#108ee9"}>

              <Upload
                name="avatar"
                listType="picture-card"
                className="edit-icon"
                showUploadList={false}
                beforeUpload={beforeUploadanner}
                onChange={handleChange}
              >
                <CameraOutlined style={{fontSize:'20px'}}/>
              </Upload>
</Tooltip>
              <div className="edit-logo-image"> 
              <Avatar
                size={100}
                icon={<UserOutlined />}
                src={logo}
                className="logo"
              />
             
              <Upload
                name="avatar"
                listType="picture-card"
                className="edit-icon"
                showUploadList={false}
                beforeUpload={beforeUpload}
                onChange={handleChange}
              >
                <CameraOutlined style={{fontSize:'20px'}}/>
              </Upload>

              </div>
             
            </div>
            <div className="rest-logo-optional-text">Optional - Update restaurant logo and banner.</div>
                
                  <Form
                    ref={formRef}
                    form={form}
                    onFinish={addRestaurant}
                    layout="vertical"
                    style={{ textAlign: "left" }}
                    initialValues={{ country: "United States" }}
                  >
                    <Form.Item
                      name="name"
                      label="Restaurant/Branch Name"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="restaurant_code"
                      label="Restaurant Code"
                      {...restaurantCodeValidationInfo}
                      rules={[
                        {
                          required: true,
                          message: "Please enter unique restaurant code",
                        },
                        {
                          pattern: /^[a-zA-Z0-9-]+$/,
                          message:
                            "Invalid characters or format in restaurant code. Only letters, numbers, and hyphens are allowed.",
                        },
                      ]}
                    >
                      <Input onBlur={validateRestaurantCode} />
                    </Form.Item>

                    <Form.Item
                      name="address"
                      label="Address"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="city"
                      label="City"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="state"
                      label="State"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select defaultValue={cusineId}>
                        {stateData.map((item) => (
                          <Option value={item.abbreviation}>{item.name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="country"
                      label="Country"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input disabled={true} />
                    </Form.Item>
                    <Form.Item
                      name="email"
                      label="Email Id"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="phone"
                      label="Phone Number"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="cuisine_id"
                      label="Cuisine"
                      rules={[
                        {
                          required: true,
                          message: "Please select a Cuisine",
                        },
                      ]}
                    >
                      <Select defaultValue={cusineId}>
                        {cusines &&
                          cusines.map((item) => (
                            <Option value={item.id}>{item.name}</Option>
                          ))}
                      </Select>
                    </Form.Item>

                    {/* <Form.Item
                      name="wait_time_minutes"
                      label="Wait Time Minutes"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <InputNumber className="input-width" />
                    </Form.Item>

                    <Form.Item
                      name="min_order_quantity"
                      label="Minimum Order Quantity"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <InputNumber className="input-width" />
                    </Form.Item>
                    <Form.Item
                      name="max_order_quantity"
                      label="Maximum Order Quantity"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <InputNumber className="input-width" />
                    </Form.Item>
                    <Form.Item
                      name="eta_pickup_order"
                      label="ETA Pickup Order"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <InputNumber className="input-width" />
                    </Form.Item>
                    <Form.Item
                      name="eta_delivery_order"
                      label="ETA Delivery Order"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <InputNumber className="input-width" />
                    </Form.Item> */}

                    <Form.Item
                      name="specialties"
                      label="Specialties (up to 3)"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        value={selectedSpeciality}
                        mode="multiple"
                        labelInValue
                        showSearch
                        onChange={handleSpeciality}
                        popupClassName="select-speciality"
                        optionLabelProp="label"
                      >
                        {speciality.map((item) => (
                          <Option
                            key={item.id}
                            value={item.id}
                            label={item.name}
                            
                          >
                            <div>
                            <Checkbox
                              checked={item.checked}
                              className="speciality-check"
                              disabled={true}
                            ></Checkbox>
                            {item.name}
                            </div>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item className="button-form">
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={loading}
                      >
                        {isEdit ? " Update" : "Submit"}
                      </Button>
                    </Form.Item>
                  </Form>
              
              </div>
            </Card>
          </div>
        </Space>
      </Content>
    </Layout>
  );
};

export default AddAndUpdateRestaurant;
